module.exports = __webpack_public_path__ + "img/icon_sports_canoe.4ccd96a5.png";